module.exports = __webpack_public_path__ + "img/section-bg.6033c786.png";